import psiPlatformAdapter from '../../psiPlatformAdapter';

export interface SnapshotData {
  cupo_snapshot: number | null;
  process_limit_snapshot: number | null;
  fecha_sync: string | null; // ISO date
}

/**
 * Snapshot de cupo de la psicóloga autenticada.
 *
 * Antes esto le pegaba directo a un webhook de Make con la URL hardcodeada acá,
 * pasando el `psychologist_id` por query. La URL terminaba en el bundle público
 * y el webhook no valida nada, así que con cambiar el id se leía el cupo de
 * cualquier psicóloga. Ahora lo sirve psiplatform-be, que saca el id del JWT.
 *
 * Ya no toma `psychologistId`: el backend no lo acepta, y si se lo volviera a
 * pasar se reabriría exactamente ese agujero. El renombre de campos
 * (`slot_snapshot` → `cupo_snapshot`, etc.) también se movió al backend.
 */
export async function fetchSnapshot(): Promise<SnapshotData> {
  return psiPlatformAdapter.metricsSnapshot();
}
